/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { contractorsAPI } from '../../services/api';

const TRADES = ['Carpentry', 'Cleaning', 'Electrical', 'Flooring', 'Gas', 'General Maintenance', 'Landscaping', 'Letting Agent', 'Plastering', 'Painting & Decorating', 'Pest Control', 'Plumbing', 'Roofing', 'Other'];

// AGENCY-001: Reusable contractor selector with an inline "+ Add New
// Contractor" shortcut — same pattern as CompanyPicker. Used to link a
// property's managing agency to a real Contractor record instead of
// free-typed text, so the same agency's details only need entering once.
export default function ContractorPicker({ value, onChange, style, placeholder }) {
  const [contractors, setContractors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newContractor, setNewContractor] = useState({ name:'', contact_name:'', trade:'Letting Agent', email:'', mobile:'', landline:'', address:'', notes:'', active:true });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    contractorsAPI.getAll().then(rows => { setContractors((rows||[]).filter(c => c.active)); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleSelect = (e) => {
    if (e.target.value === '__add_new__') { setShowAddModal(true); return; }
    onChange(e.target.value || null);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    if (!newContractor.name.trim()) { setError('Name is required'); return; }
    setSaving(true);
    try {
      const created = await contractorsAPI.create(newContractor);
      setContractors(prev => [...prev, created].sort((a,b) => a.name.localeCompare(b.name)));
      onChange(created.id);
      setShowAddModal(false);
      setNewContractor({ name:'', contact_name:'', trade:'Letting Agent', email:'', mobile:'', landline:'', address:'', notes:'', active:true });
    } catch (err) { setError(err.error || 'Failed to create contractor'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <select
        value={value || ''}
        onChange={handleSelect}
        disabled={loading}
        style={style || { width:'100%', padding:'0.5rem', border:'1px solid var(--border)', borderRadius:'0.375rem' }}
      >
        <option value="">{placeholder || '— Select a contractor —'}</option>
        {contractors.map(c => <option key={c.id} value={c.id}>{c.name}{c.trade ? ` (${c.trade})` : ''}</option>)}
        <option value="__add_new__">+ Add New Contractor…</option>
      </select>

      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="modal-header">
              <span className="modal-title">🔧 Add New Contractor</span>
              <button className="modal-close" onClick={() => setShowAddModal(false)}>×</button>
            </div>
            {error && <div className="alert alert-danger" style={{ marginBottom: '1rem' }}>{error}</div>}
            <form onSubmit={handleCreate}>
              <div className="form-group">
                <label>Company Name *</label>
                <input type="text" required value={newContractor.name} onChange={e => setNewContractor(p => ({ ...p, name: e.target.value }))} placeholder="e.g. Century 21 Brighton & Hove" autoFocus />
              </div>
              <div className="form-group">
                <label>Contact Name</label>
                <input type="text" value={newContractor.contact_name} onChange={e => setNewContractor(p => ({ ...p, contact_name: e.target.value }))} placeholder="e.g. Jane Smith" />
              </div>
              <div className="form-group">
                <label>Trade</label>
                <select value={newContractor.trade} onChange={e => setNewContractor(p => ({ ...p, trade: e.target.value }))}>
                  {TRADES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" value={newContractor.email} onChange={e => setNewContractor(p => ({ ...p, email: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Mobile</label>
                  <input type="text" value={newContractor.mobile} onChange={e => setNewContractor(p => ({ ...p, mobile: e.target.value }))} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Creating...' : '✅ Create Contractor'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
